import { BusinessActivity, SourceOfIncome } from "Infrastructure/Api/Api";
import type { IncomeInformationStepFormData } from "Components/Onboarding/BusinessEntity/Steps/IncomeInformationStep/schema";
import { FormInput } from "Components/Shared/Inputs/Form/FormInput";
import { BusinessActivityDropdown } from "Components/Shared/SelectorsForm/BusinessActivityDropdown";
import { IncomeSourceCheckboxGroup } from "Components/Shared/SelectorsForm/IncomeSourceCheckboxGroup";
import type { Control } from "react-hook-form";
import { Resources, useResource } from "Translations/Resources";
import { Stack } from "@mui/material";

const COMPONENT_RESOURCES =
  Resources.Onboarding.BusinessOnboarding.Steps.IncomeInformation;

type Props = {
  control: Control<IncomeInformationStepFormData>;
  businessActivity?: BusinessActivity;
  sourcesOfIncome: Array<SourceOfIncome>;
};

export const SharedBusinessFields = ({
  control,
  businessActivity,
  sourcesOfIncome,
}: Props) => {
  const { t } = useResource();

  const isOtherBusinessActivity =
    businessActivity === BusinessActivity.OtherAndPublicServices;
  const isOtherSourceOfIncome = sourcesOfIncome.includes(
    SourceOfIncome.OtherBusinessIncome,
  );

  return (
    <>
      <BusinessActivityDropdown
        control={control}
        name="businessActivity"
        label={t(COMPONENT_RESOURCES.Fields.BusinessActivity)}
      />
      {isOtherBusinessActivity && (
        <FormInput
          control={control}
          name="otherBusinessActivityDetails"
          label={t(COMPONENT_RESOURCES.Fields.OtherBusinessActivity)}
        />
      )}
      <Stack mb={isOtherSourceOfIncome ? 0 : 5} gap={2}>
        <IncomeSourceCheckboxGroup
          control={control}
          name="sourcesOfIncome"
          label={t(COMPONENT_RESOURCES.Fields.SourceOfIncome)}
        />
        {isOtherSourceOfIncome && (
          <FormInput
            control={control}
            name="otherSourceOfIncomeDetails"
            label={t(COMPONENT_RESOURCES.Fields.OtherSourceOfIncome)}
          />
        )}
      </Stack>
    </>
  );
};
